jQuery(function ($) {
  $(".swiper-galerie").each(function (index) {
    $(this).addClass("swiper-galerie-" + index);

    new Swiper(".swiper-galerie-" + index, {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }); 
});
